import React from 'react'
import { useContext } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import "./CheckOut.css";
import Payment from './Payment/Payment';
import { CartState } from '../Context.js';
const CheckOut = () => {
    const {
        state: { cart },
        dispatch,
      } = CartState();

      

      const [total,setTotal]=useState();
      
      useEffect(()=>{
        setTotal(
            cart.reduce((acc,curr)=>acc+Number(curr.price/100)*curr.qty,0)
        )
      },[cart])
      

  return (
    <div className='bill'>
        <div className="headtotal">
           YOUR TOTAL IS ...... 
        </div>
        <div>
            {
                cart.map((prod)=>(
                    <>
                    <div className='buy'>
                    <div className='Name'>{prod.name}</div>
                    <div className='price'>₹{(prod.price/100)}</div>
                    </div>
                    </>
                ))
            }

        </div>
        <div>
            <hr style={{backgroundColor:"black",height:"0.5rem"}}></hr>
            <div className='divTotal'>
            <div className='TotalName'>TOTAL</div>
            <div className='Total'>₹{total}</div>
            </div>
        </div>
        <div style={{display:'flex',justifyContent:'center'}}>
        <Link to={"/payment"} element={<Payment/>}>
        <button style={{border:'none',borderRadius:'1rem',backgroundColor:'#60b246',height:"3rem",width:'12rem',fontSize:'1.5rem',color:"white"}}>PAYMENT</button>
        </Link>
        </div>
    </div>
  )
}

export default CheckOut